/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_AmountInputs */

const en_admin_payments_amount = /** @type {(inputs: Admin_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const zh_admin_payments_amount = /** @type {(inputs: Admin_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金额`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Payments_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_amount = /** @type {((inputs?: Admin_Payments_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_amount(inputs)
	return zh_admin_payments_amount(inputs)
});
export { admin_payments_amount as "admin.payments.amount" }